export default __webpack_public_path__ + "32f0e59e4dba45f7f8e9a1a50a756398.svg";